import {
  cardTitle,
  successColor,
  dangerColor,
  grayColor
} from "assets/jss/material-dashboard-pro-react.js";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.js";

const regularFormsStyle = {
  ...customCheckboxRadioSwitch,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  staticFormGroup: {
    marginLeft: "0",
    marginRight: "0",
    paddingBottom: "10px",
    margin: "8px 0 0 0",
    position: "relative",
    "&:before,&:after": {
      display: "table",
      content: '" "'
    },
    "&:after": {
      clear: "both"
    }
  },
  staticFormControl: {
    marginBottom: "0",
    paddingTop: "8px",
    paddingBottom: "8px",
    minHeight: "34px"
  },
  inputAdornment: {
    marginRight: "8px",
    position: "relative"
  },
  inputAdornmentIconSuccess: {
    color: successColor[0] + "!important"
  },
  inputAdornmentIconError: {
    color: dangerColor[0] + "!important"
  },
  textCenter: {
    textAlign: 'center'
  },
  hidden:{
    display: 'none'
  },
  cardMargin:{
    marginTop: '20px'
  },
  customLabelSelect: { 
    padding: '0 5px',
    left: '15px',
    background: 'white !important',
    top: '-5px !important',
    zIndex: '1'
  },
  ...extendedFormsStyle,
  ...customInputStyle,
  bigbutton:{
    display:'inline-block',textAlign:'center',background:'#6b6198',border:'1px solid #542d84',
    borderRadius:'10px',minWidth:'320px',maxWidth:'320px',padding:'20px 15px',color:'white',
    "& H4":{
      marginBottom:'2px'
    },
    "&:hover": {
      cursor: "pointer",
      boxShadow: "0 4px 25px 0 rgba(0, 0, 0, 0.44), 0 7px 10px -5px rgba(86, 38, 130, 0.74)",
    }
  },
  bigbico:{
    width:'50px',height:'50px',padding:'5px',
  },
  modalHeader: {
    borderBottom: "none",
    paddingTop: "24px",
    paddingRight: "24px",
    paddingBottom: "0",
    paddingLeft: "24px",
    minHeight: "16.43px"
  },
  modalTitle: {
    margin: "0",
    lineHeight: "1.42857143"
  },
  modalCloseButton: {
    color: grayColor[0],
    marginTop: "-12px",
    WebkitAppearance: "none",
    padding: "0",
    cursor: "pointer",
    background: "0 0",
    border: "0",
    fontSize: "inherit",
    opacity: ".9",
    textShadow: "none",
    fontWeight: "700",
    lineHeight: "1",
    float: "right"
  },
  modalClose: {
    width: "16px",
    height: "16px"
  },
  modalMedium: {
    maxWidth: "600px",
    width: '60%'
  },
  modalLarge: {
    maxWidth: "1024px",
    width: '80%'
  },
  modalQuestion: {
    border: "1px solid #dbdbdb",
    borderRadius: "0.625rem",
    margin: "0.2rem",
    padding: "0.75rem"
  }
};

export default regularFormsStyle;
